export default __webpack_public_path__ + "static/thebottomline4-4eb8a8845e147ec4f0fb2cee01d9f97e.jpg";